/* eslint-disable react-hooks/exhaustive-deps */
import urlOptionsTemplate from '@bingads-webui-campaign-legacy/advanced-settings/template/url-options.pug';
import UpgradedUrlOptions from '@bingads-webui-component-legacy/upgraded-url/view/advancedSettingsUrlOptions';
import '@bingads-webui-campaign/ko-stop-binding';
import _ from 'underscore';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './style';
import { useBackboneView, } from '../shared';


// reference: private/campaign-legacy/packages/advanced-settings/view/advancedSettings.js
export const UrlOptions = React.memo((props) => {
  const {
    setUrlOptionsView, options: {
      level, campaignId, adgroupId, model,
    },
  } = props;

  const urlOptions = new UpgradedUrlOptions({
    editMode: true,
    entityType: level,
    isNewUI: true,
    trackingTemplate: _.result(model, 'TrackingUrlTemplate'),
    finalUrlSuffix: _.result(model, 'FinalUrlSuffix'),
    customParameters: _.isEmpty(model.UrlCustomParameters) ? undefined : model.UrlCustomParameters,
    urlOptionsTemplate,
    showUurlTestTool: false,
    campaignId,
    adGroupId: adgroupId,
  });
  const urlOptionsReactWrapper = useBackboneView(useCallback(() => urlOptions.render(), [model]), setUrlOptionsView, { managed: true });
  const classes = useDefaultStyles(getStyles);

  // useEffect(() => { urlOptions.expandSettings(true, true, true); }, [model]);

  return (
    <div className={classnames(classes.urlOptionsContainer)}>
      <div className="urloptions-wraper clearfix">
        {urlOptionsReactWrapper}
      </div>
    </div>
  );
}, (prevProps, nextProps) => prevProps.options.model === nextProps.options.model);

UrlOptions.propTypes = {
  setUrlOptionsView: PropTypes.func.isRequired,
  options: PropTypes.shape({}),
};

UrlOptions.defaultProps = {
  options: {
  },
};
